// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.amex {
	color: #2E77BB;
}

.visa {
	color: #192061;
}

.master {
	color: #EB001B;
}

.discover {
	color: #F9A021;
}`, "",{"version":3,"sources":["webpack://./src/app/components/stripe/stripe-choose-payment-method/stripe-choose-payment-method.component.css"],"names":[],"mappings":"AAAA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf","sourcesContent":[".amex {\n\tcolor: #2E77BB;\n}\n\n.visa {\n\tcolor: #192061;\n}\n\n.master {\n\tcolor: #EB001B;\n}\n\n.discover {\n\tcolor: #F9A021;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
